import { Component, OnInit, ViewChild, ElementRef, Input, ViewEncapsulation } from '@angular/core';

declare var WE: any;

interface Options {
  center?: Array<number>; // Lat, lng center of view.
  zoom?: number; // Sets zoom.
  altitude?: number; // Sets altitude of view in meters.
  atmosphere?: boolean; // Show the athmosphere. Best used with black background sets by CSS.
  sky?: boolean; // Show stars.
  minAltitude?: number; // Sets lower altitude limit for interactions.
  maxAltitude?: number; // Sets upper altitude limit for interactions.
  dragging?: boolean; // Allow interaction.
  tilting?: boolean; // Allow tilt the view.
  zooming?: boolean; // Allow zooming.
  scrollWheelZoom?: boolean; // Sets mouse scroll wheel zoom.
  unconstrainedRotation?: boolean; // Modifies the interaction to allow arbitrary rotation (unconstrained by Z axis).
  proxyHost?: string; // Link to proxy map tiles cross-domain (without CORS headers on server).
}

@Component({
  selector: 'sj-ng-webgl-globe',
  templateUrl: 'sj-ng-webgl-globe.component.html',
  styles: [`
    .cesium-credit-textContainer{
      display: none;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class SjNgWebglGlobeComponent implements OnInit {

  globe: any;
  options: Options = {
    center: [null, null],
    zoom: null,
    altitude: 7000000,
    atmosphere: false,
    sky: false,
    minAltitude: 20,
    dragging: true,
    tilting: true,
    zooming: true,
    scrollWheelZoom: true,
    unconstrainedRotation: false,
    proxyHost: ''
  };

  @ViewChild('sjGlobe', { static: true }) sjGlobe: ElementRef;

  @Input('center') center?: Array<number>; // Lat, lng center of view.
  @Input('zoom') zoom?: number; // Sets zoom.
  @Input('altitude') altitude?: number; // Sets altitude of view in meters.
  @Input('atmosphere') atmosphere?: boolean; // Show the athmosphere. Best used with black background sets by CSS.
  @Input('sky') sky?: boolean; // Show stars.
  @Input('minAltitude') minAltitude?: number; // Sets lower altitude limit for interactions.
  @Input('maxAltitude') maxAltitude?: number; // Sets upper altitude limit for interactions.
  @Input('dragging') dragging?: boolean; // Allow interaction.
  @Input('tilting') tilting?: boolean; // Allow tilt the view.
  @Input('zooming') zooming?: boolean; // Allow zooming.
  @Input('scrollWheelZoom') scrollWheelZoom?: boolean; // Sets mouse scroll wheel zoom.
  @Input('unconstrainedRotation') unconstrainedRotation?: boolean; // Modifies the interaction to allow arbitrary rotation (unconstrained by Z axis).
  @Input('proxyHost') proxyHost?: string; // Link to proxy map tiles cross-domain (without CORS headers on server).

  @Input('markers') markers: Array<any>; // Marker data
  constructor() { }

  ngOnInit() {
    this.options = {
      center: this.center,
      zoom: this.zoom,
      altitude: this.altitude,
      atmosphere: this.atmosphere,
      sky: this.sky,
      minAltitude: this.minAltitude,
      maxAltitude: this.maxAltitude,
      dragging: this.dragging,
      tilting: this.tilting,
      zooming: this.zooming,
      scrollWheelZoom: this.scrollWheelZoom,
      unconstrainedRotation: this.unconstrainedRotation,
      proxyHost: this.proxyHost
    };
    this.globe = new WE.map(this.sjGlobe.nativeElement, this.options);

    WE.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(this.globe);

    console.log(this.markers);
    if (this.markers !== undefined && this.markers.length > 0) {
      this.markers.forEach((m, i) => {
        const marker = WE.marker([m.latitude, m.longitude]).addTo(this.globe);
        if (m.isPopupEnable) {
          marker.bindPopup(m.popupHTML, { maxWidth: 200, closeButton: false });
        }
      });
    }
  }

}
